<script lang="ts">
export default {
  name: 'KkGrowthRate',
}
</script>

<script lang="ts" setup>
import { computed, useCssModule } from 'vue'
import { KkIcon } from 'src/biz_spa/components/base'

export interface Props {
  rate: number
  size?: 'sm' | 'md'
}

const props = withDefaults(defineProps<Props>(), { size: 'sm' })
const styles = useCssModule()

const styledClasses = computed(() => {
  const classes: string[] = [styles.rate, styles[props.size]]
  if (props.rate > 0) classes.push(styles.up)
  if (props.rate < 0) classes.push(styles.down)
  return classes
})
</script>

<template>
  <span :class="styledClasses">
    {{ props.rate }}%
    <KkIcon v-if="props.rate !== 0" :name="props.rate > 0 ? 'arrowUp' : 'arrowDown'" color="currentColor" :class="$style.icon" />
  </span>
</template>

<style lang="scss" module>
@import '../../../../../../stylesheets/biz_spa/foundation/var';

.rate {
  position: relative;
  display: inline-block;
  padding-right: 20px;

  &.up {
    color: $complete-color;
  }

  &.down {
    color: $color-accent-primary
  }

  &.sm {
    font-size: 14px;
    font-weight: normal;
    line-height: 1.7;
  }

  &.md {
    font-size: 18px;
    font-weight: bold;
    line-height: 1.3;
  }
}

.icon {
  position: absolute;
  top: 50%;
  right: 0;
  width: 16px !important;
  transform: translateY(-50%);
}
</style>

